import { useTranslation } from "react-i18next";

import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

import { TalkRatioList } from "./TalkRatioList";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionTalkRatio() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <SectionLayout data-test="talk-ratio-section">
      <SectionHeader>{t("call_context.talk_ratio")}</SectionHeader>
      <TalkRatioList speakers={call.speakers} talkRatio={call.talkRatio} />
    </SectionLayout>
  );
}
